<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="default"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        :data-url="
          selectedUrl
            ? `/accreditations/accBodies/${inputs.id}`
            : '/accreditations/accBodies'
        "
      >
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>Organismo de Acreditación</label>
              <app-input
                type="text"
                v-model="inputs.name"
                placeholder="Ingrese el nombre del organismo de acreditación"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Alcance</label>
              <app-input
                type="textarea"
                v-model="inputs.scope"
                :required="true"
                placeholder="Ingrese el alcance"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>Estado</label>
              <app-input
                type="select"
                v-model="inputs.status"
                :required="true"
                :list="[
                  { id: '', value: this.$t('select_option') },
                  ...this.status,
                ]"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        @click.prevent="submit"
        :disabled="disabledSubmit"
      >
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    selectedUrl: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      modalId: "add-edit-modal",
      status: [
        { id: "Solicitud Presentada", value: "Solicitud Presentada" },
        { id: "Vigente", value: "Vigente" },
        { id: "Suspendida", value: "Suspendida" },
        { id: "Retirada", value: "Retirada" },
      ],
      disabledSubmit: false,
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? "Editar" : "Registrar";
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.inputs.acc_app_id = this.$store.state.accreditation.id;
      this.disabledSubmit = true;
      this.save(this.inputs);
    },

    afterJsValidationFail() {
      this.disabledSubmit = false;
    },

    afterSuccess(response) {
      if (this.inputs.id) {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.preloader = false;
    },
  },
};
</script>
